import { useState } from 'react';
import { PositionSelection } from '../../types/positionSelection.ts';
import { Protocol } from '../../types/sharedTypeImpl.ts';


interface Props {
    protocol: Protocol | null;
    setProtocol: (protocol: Protocol) => void;
    setIsDirty: (isDirty: boolean) => void;
    setPositionSelection: (positionSelection: PositionSelection | null) => void;
}

export function useDragReorder({
    protocol,
    setProtocol,
    setIsDirty,
    setPositionSelection
}: Props) {
    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);

    function handleDragStart(positionIndex: number) {
        setDraggedIndex(positionIndex);
    }

    function handleDrop(targetIndex: number) {
        if (protocol === null) return;
        if (draggedIndex === null) return;
        if (draggedIndex === targetIndex) return;

        // Create a reordered copy
        const reordered = [...protocol.positions];
        const [removed] = reordered.splice(draggedIndex, 1);
        reordered.splice(targetIndex, 0, removed);

        setProtocol({
            ...protocol,
            positions: reordered,
        });
        setIsDirty(true);
        setPositionSelection({ positionIdx: targetIndex });
        setDraggedIndex(null);
    }

    return {
        draggedIndex,
        handleDragStart,
        handleDrop,
    }
}
